import React from 'react';

export default function OrderDashboardHeader({
  orderScope,
  onScopeChange,
  totalMatching,
  loadedCount,
  backgroundSyncing,
  loading,
  fetchOrders,
  onSyncNow,
  onShowAddOrder,
  showCsvUpload,
  setShowCsvUpload,
  showExportDropdown,
  setShowExportDropdown,
  exportScope,
  setExportScope,
  exporting,
  exportToCSV,
  exportToExcel,
  onShowSubscription,
  onClearCache,
}) {
  return (
    <div className="dashboard-header">
      <div className="header-info">
        <div className="order-scope-switcher">
          <button
            type="button"
            className={`scope-pill ${orderScope === 'all' ? 'active' : ''}`}
            onClick={() => onScopeChange('all')}
          >
            <span className="scope-dot all" />
            All
          </button>
          <button
            type="button"
            className={`scope-pill ${orderScope === 'shipping' ? 'active' : ''}`}
            onClick={() => onScopeChange('shipping')}
          >
            <span className="scope-dot shipping" />
            Shipping Required
          </button>
          <button
            type="button"
            className={`scope-pill ${orderScope === 'digital' ? 'active' : ''}`}
            onClick={() => onScopeChange('digital')}
          >
            <span className="scope-dot digital" />
            Non Shipping
          </button>
        </div>
        <p className="orders-count">
          Matching: {totalMatching} | Loaded: {loadedCount}
          {backgroundSyncing ? ' | Syncing…' : ''}
        </p>
      </div>
      <div className="action-buttons-header">
        <button
          onClick={() => fetchOrders(orderScope, { reset: true })}
          className="refresh-btn"
          disabled={loading}
        >
          Refresh Orders
        </button>
        <button
          onClick={onSyncNow}
          className="refresh-btn"
          disabled={loading || backgroundSyncing}
          title="Pull latest orders from Shopify now"
        >
          {backgroundSyncing ? 'Syncing…' : 'Sync Now'}
        </button>
        <button onClick={onShowAddOrder} className="refresh-btn" title="Create a manual order">
          Add Order
        </button>
        <button
          onClick={() => setShowCsvUpload(!showCsvUpload)}
          className="csv-upload-toggle-btn"
        >
          {showCsvUpload ? 'Hide' : 'Show'} CSV Upload
        </button>
        <div className="export-dropdown-container">
          <button
            onClick={() => setShowExportDropdown(!showExportDropdown)}
            className="export-dropdown-btn"
            title="Export all matching filtered orders"
            disabled={exporting}
          >
            {exporting ? 'Exporting…' : 'Export Data ▼'}
          </button>
          {showExportDropdown && (
            <div className="export-dropdown-menu">
              <div className="export-scope-label">Export Scope</div>
              <div className="order-scope-switcher export-scope-switcher">
                <button
                  type="button"
                  className={`scope-pill ${exportScope === 'all' ? 'active' : ''}`}
                  onClick={() => setExportScope('all')}
                  disabled={exporting}
                >
                  <span className="scope-dot all" />
                  All
                </button>
                <button
                  type="button"
                  className={`scope-pill ${exportScope === 'shipping' ? 'active' : ''}`}
                  onClick={() => setExportScope('shipping')}
                  disabled={exporting}
                >
                  <span className="scope-dot shipping" />
                  Shipping Required
                </button>
                <button
                  type="button"
                  className={`scope-pill ${exportScope === 'digital' ? 'active' : ''}`}
                  onClick={() => setExportScope('digital')}
                  disabled={exporting}
                >
                  <span className="scope-dot digital" />
                  Non Shipping
                </button>
              </div>
              <button
                onClick={() => {
                  exportToCSV(exportScope);
                  setShowExportDropdown(false);
                }}
                className="export-option-btn"
                disabled={exporting}
              >
                {exporting ? 'Exporting…' : 'Export as CSV'}
              </button>
              <button
                onClick={() => {
                  exportToExcel(exportScope);
                  setShowExportDropdown(false);
                }}
                className="export-option-btn"
                disabled={exporting}
              >
                {exporting ? 'Exporting…' : '📈 Export as Excel'}
              </button>
            </div>
          )}
        </div>
        <button
          type="button"
          onClick={onShowSubscription}
          className="subscription-order-btn"
          title="Open Shopify Subscription Tracker sheet"
        >
          Subscription Order
        </button>
        <button
          onClick={onClearCache}
          className="debug-btn"
          title="Clear cache and email tracking data (preserves order conversions)"
          style={{ display: 'none' }}
        >
          Debug Email Data
        </button>
      </div>
    </div>
  );
}
